<template>
  <div
    ref="multiselect"
    class="multiselect__container"
  >
    <div
      class="multiselect__input_container"
    >
      <b-form-input
        :id="input.id"
        v-model="displayValue"
        :class="inputClass"
        :state="inputState"
        :placeholder="placeholder"
        :readonly="true"
        :disabled="disabled"
        @click="toggleDropdown"
      />
      <b-spinner
        v-show="spinner"
        class="multiselect__spinner"
        variant="primary"
        label="Betöltés"
        small
      />
    </div>
    <div
      v-show="open"
      ref="dropdown"
      class="dropdown-menu p-0 w-100 multiselect__dropdown"
    >
      <div
        ref="dropdownItems"
        class="multiselect__dropdown-items p-2 mb-1"
      >
        <b-form-checkbox
          v-for="(element, index) in list"
          :key="index"
          :checked="element.selected"
          @change="toggleSelected(element)"
        >
          {{ element.name }}
        </b-form-checkbox>
      </div>
      <b-button
        class="w-100"
        variant="success"
        size="sm"
        @click="$emit('add')"
      >
        <i class="fas fa-plus-square" />
      </b-button>
    </div>
    <b-tooltip
      v-if="!open"
      :target="() => $refs.multiselect"
      :delay="500"
      placement="bottom"
    >
      <div
        v-for="(element, index) in value"
        :key="index"
        v-text="element.name"
      />
    </b-tooltip>
  </div>
</template>
<style>
  .multiselect__input[readonly]:not([disabled]) {
    background-color: var(--white);
  }
  .multiselect__container, .multiselect__input_container {
    position: relative;
  }
  .multiselect__dropdown {
    display: block;
  }
  .multiselect__dropdown-items {
    max-height: 200px;
    overflow-y: auto;
  }
  .multiselect__spinner {
    position: absolute;
    right: 10px;
    top: calc(50% - .5rem);
  }

</style>
<script>
export default {
  props: {
    value: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      default: 'Válassz egy elemet'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    spinner: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => ([])
    },
    input: {
      type: Object,
      default: () => ({
        class: 'form-control',
        id: ''
      })
    },
    state: {
      type: Boolean,
      validator: prop => typeof prop === 'boolean' || prop === null,
    },
    formatValue: {
      type: Function,
      default: (value) => {
        return _.map(value, (element) => element.name).join(', ')
      }
    },
  },
  data() {
    return {
      open: false,
      activeModal: null
    }
  },
  computed: {
    list() {
      return _.map(this.options, (option) => ({
        ...option,
        selected: this.selected.has(option.id)
      }))
    },
    selected() {
      return new Set(_.map(this.value, element => element.id))
    },
    displayValue() {
      return this.formatValue(this.value)
    },
    inputState() {
      if(this.spinner) {
        return null
      } else {
        return this.state
      }
    },
    inputClass() {
      var classes = ['multiselect__input']

      if(this.spinner) {
        classes.push(['border', 'border-primary'])
      }

      return classes
    }
  },
  watch: {
    options() {
      this.$nextTick(() => {
        this.$refs.dropdownItems.scrollTop = this.$refs.dropdownItems.lastElementChild.offsetTop
      })
    }
  },
  mounted() {
    document.addEventListener('click', this.documentClick)
    this.inputValue = this.formatValue(this.value)
    this.$root.$on('bv::modal::shown', this.modalShown)
    this.$root.$on('bv::modal::hidden', this.modalHidden)
  },
  methods: {
    toggleDropdown() {
      if(this.disabled) {
        return
      }

      this.open = !this.open
    },
    toggleSelected(target) {
      if(target.selected) {
        this.$emit('input', _.filter(this.value, (element) => element.id !== target.id))
      } else {
        this.$emit('input', _.concat(this.value, _.omit(target, 'selected')))
      }
    },
    modalShown(e) {
      this.activeModal = e.target
    },
    modalHidden() {
      this.activeModal = null
    },
    documentClick(e) {
      // don't close if the click was inside the multiselect
      if(this.$refs.multiselect.contains(e.target)) {
        return
      }

      // don't close if there is an active modal and this multiselect isn't on it
      if(this.activeModal && !this.activeModal.contains(this.$refs.multiselect)) {
        return
      }

      // close otherwise
      this.open = false
    }
  }
}
</script>